import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e2d1472&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e2d1472&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2e2d1472&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d1472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2d1472')) {
      api.createRecord('2e2d1472', component.options)
    } else {
      api.reload('2e2d1472', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e2d1472&scoped=true", function () {
      api.rerender('2e2d1472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabTable/index.vue"
export default component.exports